/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = ['$scope'];

const StatusSelectorCtrl = function ($scope) {
  const statuses = [
    {
      name(dp) {
        return dp || 'Ready';
      },
      icon: 'bl-icon-notification-bell',
      class: 'status-ready',
      status: 'READY',
    },
    {
      name() {
        return 'Sent';
      },
      icon: 'bl-icon-post-message',
      class: 'status-sent',
      status: 'SENT',
    },
    {
      name() {
        return 'Received';
      },
      icon: 'bl-icon-mail',
      class: 'status-sent',
      status: 'RECEIVED',
    },
    {
      name(dp) {
        return dp;
      },
      icon: 'bl-icon-person',
      class: 'status-sent',
      status: 'ASSIGNED',
    },
    {
      name() {
        return 'Re-sent';
      },
      icon: 'bl-icon-post-message',
      class: 'status-sent',
      status: 'REJECTED_BY_BK',
    },
    {
      name(dp) {
        return dp;
      },
      icon: 'bl-icon-abacus',
      class: 'status-in-process',
      status: 'IN_PROGRESS',
    },
    {
      name(dp) {
        return dp;
      },
      icon: 'bl-icon-checkmark',
      class: 'status-reconcile',
      status: 'PROCESSED_BY_DP',
    },
    {
      name() {
        return 'Processed by BK';
      },
      icon: 'bl-icon-checkmark',
      class: 'status-complete',
      status: 'PROCESSED_BY_BK',
    },
    {
      name() {
        return 'Rejected';
      },
      icon: 'bl-icon-close',
      class: 'status-rejected',
      status: 'REJECTED_BY_DP',
    },
    {
      name() {
        return 'Rec Posted';
      },
      icon: 'bl-icon-checkmark',
      class: 'status-complete',
      status: 'POSTED',
    },
    {
      name() {
        return 'Rec Pending';
      },
      icon: 'bl-icon-abacus',
      class: 'status-in-process',
      status: 'PENDING',
    },
    {
      name() {
        return 'Rec Ignored';
      },
      icon: 'bl-icon-close',
      class: 'status-rejected',
      status: 'IGNORED',
    },
    {
      name() {
        return 'Rec Autoposted';
      },
      icon: 'bl-icon-checkmark',
      class: 'status-complete',
      status: 'AUTOPOSTED',
    },
  ];

  const statusesToShowTicketId = ['RECEIVED', 'ASSIGNED', 'IN_PROGRESS', 'PROCESSED_BY_DP'];
  const statusesToShowTimestamp = ['SENT', 'RECEIVED', 'ASSIGNED', 'IN_PROGRESS'];

  const isProcessedByAI = () =>
    this.dpName && this.dpName.toLowerCase().includes('processed by ai');

  // Use accountStatementStatus if dataProcessor is "Processed by AI"
  const getEffectiveStatus = () => {
    if (isProcessedByAI() && this.accountStatementStatus) {
      return this.accountStatementStatus;
    }
    return this.dpStatus;
  };

  const effectiveStatus = getEffectiveStatus();
  this.showTicketId = this.dpTicketId && statusesToShowTicketId.includes(effectiveStatus);
  this.showSentTimestamp =
    this.dpSentTimestamp && statusesToShowTimestamp.includes(effectiveStatus);

  $scope.$watchGroup(['vm.dpStatus', 'vm.accountStatementStatus', 'vm.dpName', 'vm.dpNote'], () => {
    const status = getEffectiveStatus();
    this.status = _.find(statuses, s => s.status === status);
    this.showNote = this.dpNote;
  });
};

StatusSelectorCtrl.$inject = deps;

module.exports = StatusSelectorCtrl;
